import React from 'react';
import { Heading, Text } from '@chakra-ui/react';

const Footer = (props) => {
  return (
    <></>
  );
};

export default Footer;